import { render, staticRenderFns } from "./EmployeeAuthorization.vue?vue&type=template&id=2ac28838&scoped=true"
import script from "./EmployeeAuthorization.vue?vue&type=script&lang=js"
export * from "./EmployeeAuthorization.vue?vue&type=script&lang=js"
import style0 from "./EmployeeAuthorization.vue?vue&type=style&index=0&id=2ac28838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac28838",
  null
  
)

export default component.exports